/* eslint-disable react/forbid-dom-props */
import { ResponsivePie } from '@nivo/pie';
import { GREY_500, GREY_700 } from '../../../../../constants';

export interface ChannelPieDatum {
    id: string;
    label: string;
    value: number;
    color: string;
}

const LegendTitle = (props: {
    centerX: number;
    centerY: number;
}) => {
    const { centerX, centerY } = props;
    return (
        <text
            x={centerX}
            y={2 * centerY + 56}
            style={{
                fill: GREY_700,
                fontSize: '14px',
                fontWeight: 'bold',
                textAnchor: 'middle',
            }}
        >
            Opportunities
        </text>
    );
};

const ChannelOpportunitiesPie = ({ data: chartData = [] }: { data: ChannelPieDatum[] }) => {
    const hasSlices = chartData.length > 0;

    if (!hasSlices) {
        return (
            <div className="rainbow-p-around_small rainbow-text-color_gray">
                No opportunity breakdown for this period.
            </div>
        );
    }

    return (
        <div style={{ height: 240, width: '100%' }}>
            <ResponsivePie
                data={chartData}
                margin={{
                    top: 12, right: 12, bottom: 64, left: 12,
                }}
                innerRadius={0.58}
                padAngle={1.5}
                cornerRadius={3}
                activeOuterRadiusOffset={6}
                colors={(d) => d.data.color}
                borderWidth={1}
                borderColor={{ from: 'color', modifiers: [['darker', 0.35]] }}
                enableArcLinkLabels={false}
                arcLabelsSkipAngle={14}
                arcLabelsTextColor="#FFFFFF"
                arcLabel={(d) => (d.value >= 1 ? Math.round(Number(d.value)).toLocaleString() : '')}
                legends={[
                    {
                        anchor: 'bottom',
                        direction: 'row',
                        translateY: 36,
                        itemWidth: 78,
                        itemHeight: 14,
                        itemsSpacing: 4,
                        symbolSize: 10,
                        symbolShape: 'circle',
                        itemTextColor: GREY_500,
                        translateX: 10,
                    },
                ]}
                theme={{
                    labels: { text: { fontSize: 11, fontWeight: 600 } },
                    legends: { text: { fontSize: 11 } },
                }}
                layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends', LegendTitle]}
            />
        </div>
    );
};

export default ChannelOpportunitiesPie;
